import { PhoneNumberPipe } from './phone-number.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [PhoneNumberPipe],
  providers: [PhoneNumberPipe],
  exports: [PhoneNumberPipe]
})
export class PhoneNumberPipeModule { }
